import React, {  useState } from "react";
import { ColumnDirective, Grid, ColumnsDirective, Resize, GridComponent, Inject, Page, Sort, Filter, Group } from '@syncfusion/ej2-react-grids';
import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import useSave from "../../Hooks/useSave";
import useDelete from "../../Hooks/useDelete";
import useUpdate from "../../Hooks/useUpdate";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import Select from "react-select";
import useFetchData from "../../Hooks/useFetchData";
import useValidateRole from "../../Hooks/useValidateRole";
const BankBranch = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setview] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Banks");
    const Bank = useFetchData("api/Bank");
    const url = "api/Bankbranch";
    const dataurl = process.env.REACT_APP_BASE_URL + 'api/Bankbranch/Allbanksbranch';
    let grid = Grid | null;

    const handleOpenModal = (event) => {
        //event.persist();
        setInputs({});
        setOpen(true);
    };
    const handleSelectChange = (UserGroup, actionMeta) => {
        setInputs((inputs) => ({ ...inputs, [actionMeta.name]: UserGroup.value }));
    };
    const BankOptions = [];
    if (Bank.response) {
        Bank.response.map((k, i) => {
            let col = {
                value: k.id,
                label: k.name,
            };
            BankOptions.push(col);
        });
    }
    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setview(false);
        } else {
            alert("Select a record to edit");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setview(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }
    };
    const handleSelect = (k, event) => {
       
        setInputs(k.data);
    };
    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setview(false);
        setUpdate(false);
    };
    const HandleSave = () => {
        useSave(url, inputs);
        grid.refresh();
    };
    const HandleUpdate = () => {
        let data={
            id:inputs.id,
            bankId:inputs.bankId,
            name:inputs.name,
            code:inputs.code
        }
        useUpdate(url + "/" + inputs.id, data);
        grid.refresh();

    };
    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }
        setOpen(false);
    };
    const CallDeletehook = () => {
        useDelete(url + "/" + inputs.id);
        grid.refresh();
    };
    const HandelDelete = () => {
        if (inputs.id) {
            CallDeletehook();
        } else {
            alert("Select a record to delete");
        }
    };

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-success p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
        &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandelDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
        &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
        </button>
            </div>
        );
    };
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Bank Branch</li>
            </ol>
            <h1 class="page-header mb-3">Bank Branch</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div class="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandelDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                    <GridComponent ref={g => grid = g}
              allowPaging={true}
              allowResizing={true}
              allowTextWrap={true}
              allowFiltering={true}
              rowSelected={(args) => {
                handleSelect(args);
              }}
              dataSource={new DataManager({
                adaptor: new UrlAdaptor(),
                crossDomain: true,
                url: dataurl,
                headers: [{
                  Authorization: "Bearer " + window.sessionStorage.getItem("xtoken")
                }]
              })
              }>
              <ColumnsDirective>
                <ColumnDirective field='id' headerText='id' visible={false} />
                <ColumnDirective field='code' headerText='Code' />
                <ColumnDirective field='name' headerText='Name' />
                <ColumnDirective field='bank' headerText='Bank' />
              </ColumnsDirective>
              <Inject services={[Page, Sort, Resize, Filter]} />
            </GridComponent>
                    </div>
                </div>
            </div>

            <Modal visible={open} width="40%" height="40%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
          </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 fontWeight-bold text-blue">
                                bank Branch
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Bank Branch</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>{inputs.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Code:</td>
                                                    <td>{inputs.code}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Bank:</td>
                                                    <td>{inputs.bank  }</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className=" row">
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Bank</label>
                                                    <div class="col-md-9">
                                                        <Select
                                                            name="bankId"
                                                            value={BankOptions.filter(
                                                                (option) => option.value === inputs.bankId
                                                            )}
                                                            //defaultInputValue={inputs.securityGroupId}
                                                            onChange={handleSelectChange}
                                                            options={BankOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Code</label>
                                                    <div class="col-md-9">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="code"
                                                            required
                                                            value={inputs.code}
                                                            onChange={handleInputChange}
                                                        // defaultvalue={inputs.name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div class="form-group row m-b-15">
                                                    <label class="col-form-label col-md-3">Name</label>
                                                    <div class="col-md-9">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="name"
                                                            required
                                                            value={inputs.name}
                                                            onChange={handleInputChange}
                                                        // defaultvalue={inputs.name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div
                                            style={{ display: "flex", "justify-content": "flex-end" }}
                                        >
                                            <div class="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-success p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                        &nbsp;
                        <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                        </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
export default BankBranch;

